import { logMissingConfig } from '../utils/errorHandlers';

const normalizeBaseUrl = (url) => {
  if (!url) {
    return '';
  }
  return url.replace(/\/$/, '');
};

const getFlyerIdentifier = ({ flyerId, tournamentId } = {}) => flyerId || tournamentId;

export const buildFlyerUrl = ({ flyerId, tournamentId } = {}) => {
  const baseUrl = process.env.REACT_APP_FLYER_BASE_URL && process.env.REACT_APP_FLYER_BASE_URL.trim();

  if (!baseUrl) {
    logMissingConfig('flyerService', 'REACT_APP_FLYER_BASE_URL', '– cannot render flyer.');
    return null;
  }

  const flyerIdentifier = getFlyerIdentifier({ flyerId, tournamentId });
  if (!flyerIdentifier) {
    return null;
  }

  const safeTournamentId = encodeURIComponent(flyerIdentifier);
  const normalizedBase = normalizeBaseUrl(baseUrl);

  return `${normalizedBase}/${safeTournamentId}.png`;
};
